import { type MessageDescriptor } from 'react-intl';

import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	['ctaTitle', 'ctaDescription', 'ctaLink', 'whyAmISeeingThisReason']
> = defineContent({
	default: {
		ctaTitle: {
			id: 'jira-twg-cli-cta.cta-title',
			defaultMessage: 'Bring Jira context into your terminal',
			description: 'CTA title for the Jira TWG CLI CTA',
			role: 'title',
		},
		ctaDescription: {
			id: 'jira-twg-cli-cta.cta-description',
			defaultMessage:
				'Give your agents better Jira context while using fewer credits. Query open work items and pull related tasks with Teamwork Graph CLI.',
			description: 'CTA description for the Jira TWG CLI CTA',
			role: 'description',
		},
		ctaLink: {
			id: 'jira-twg-cli-cta.cta-link',
			defaultMessage: 'Install the CLI',
			description: 'CTA link text for the Jira TWG CLI CTA',
		},
		whyAmISeeingThisReason: {
			id: 'jira-twg-cli-cta.why-am-i-seeing-this-reason',
			defaultMessage: 'You have indicated interest in using coding agents',
			description: 'Reason for why the user is seeing the Jira TWG CLI CTA',
		},
	},
});

export const messages: {
	ctaTitle: MessageDescriptor;
	ctaDescription: MessageDescriptor;
	ctaLink: MessageDescriptor;
	whyAmISeeingThisReason: MessageDescriptor;
} = registeredContent.default;
